module.exports = __webpack_public_path__ + "media/bundles/bundles-right-15f5d9da.svg";